<template>
  <div class="service-units">
    <div class="title">服务单位信息</div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="scroll-content" ref="scrollContent">
        <div v-for="(unit, index) in serviceUnits" :key="index" class="unit-item">
          <div class="unit-header">
            <img :src="unit.logo" alt="" class="unit-logo">
            <div class="unit-info">
              <div class="unit-name">{{ unit.name }}</div>
              <div class="unit-scale">{{ unit.scale }}</div>
              <div class="unit-field">{{ unit.field }}</div>
            </div>
          </div>
<!--          <div class="unit-content">-->
<!--            <div class="unit-field">{{ unit.field }}</div>-->
<!--            <div class="unit-scale">{{ unit.scale }}</div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EnterpriseInfoController } from '../../../api';
export default {
  name: 'ServiceUnits',
  props: {
    cityName: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 服务单位数据
      serviceUnits: [],
      scrollTimer: null,
      scrollSpeed: 1 // 滚动速度
    }
  },
  mounted () {
    // 根据cityName获取实际的服务单位数据
    this.fetchServiceUnits();
    this.startScroll();
  },
  beforeDestroy () {
    this.stopScroll();
  },
  methods: {
    // 根据location获取服务单位数据
    fetchServiceUnits () {
      const location = this.cityName;
      if (!location) {
        console.warn('没有提供location参数，无法获取服务单位数据');
        return;
      }

      console.log('开始获取服务单位数据，location:', location);

      // 构造查询参数
      const params = {
        enterpriseInfoDtoFilter: {
          location: location // 以地图名称作为位置查询条件
        }
      };

      // 调用API查询企业信息
      EnterpriseInfoController.list(this, params).then(res => {
        console.log('企业信息API返回结果：', res);

        // 处理API返回结果
        let enterpriseList = [];
        if (res && res.data && res.data.dataList) {
          enterpriseList = res.data.dataList;
        } else if (res && res.data && res.data.list) {
          enterpriseList = res.data.list;
        }

        if (enterpriseList.length > 0) {
          // 将查询结果转换为组件需要的数据格式
          this.serviceUnits = enterpriseList.map(enterprise => {
            return {
              logo: enterprise.logo || require('../../../assets/img/bigScreen/qiye.png'),
              name: enterprise.enterpriseName || '未知企业',
              field: `【技术领域】${enterprise.technologyField || '未知'}`,
              scale: `【联系方式】${enterprise.contactInfo || '未知'} `
            };
          });

          // 复制数据，实现无缝滚动
          this.serviceUnits = [...this.serviceUnits, ...this.serviceUnits];
          console.log('获取到的服务单位数据：', this.serviceUnits);
        } else {
          console.warn('没有获取到服务单位数据');
          // 如果没有数据，使用默认数据
          this.serviceUnits = [
            {
              logo: require('../../../assets/img/bigScreen/qiye.png'),
              name: '暂无企业数据',
              code: '',
              field: '',
              scale: ''
            }
          ];
        }
      }).catch(err => {
        console.error('获取服务单位数据出错：', err);
        // 出错时使用默认数据
        this.serviceUnits = [
          {
            logo: require('../../../assets/img/bigScreen/qiye.png'),
            name: '获取数据失败',
            code: '',
            field: '',
            scale: ''
          }
        ];
      });
    },
    startScroll () {
      const scrollContainer = this.$refs.scrollContainer;
      const scrollContent = this.$refs.scrollContent;

      if (!scrollContainer || !scrollContent) return;

      this.scrollTimer = setInterval(() => {
        scrollContainer.scrollTop += this.scrollSpeed;

        // 当滚动到原始数据的一半时，无缝跳回开头
        if (scrollContainer.scrollTop >= scrollContent.scrollHeight / 2) {
          scrollContainer.scrollTop = 0;
        }
      }, 30);
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    }
  },
  watch: {
    cityName (newVal) {
      if (newVal) {
        this.fetchServiceUnits();
      }
    }
  }
}
</script>

<style scoped>
.service-units {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.scroll-container {
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  width: 100%;
  padding-right: 20px;
  box-sizing: border-box;
}

/* 自定义滚动条样式 */
.service-units::-webkit-scrollbar {
  width: 8px;
}

.service-units::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.service-units::-webkit-scrollbar-thumb {
  background: rgba(1, 185, 183, 0.7);
  border-radius: 4px;
}

.service-units::-webkit-scrollbar-thumb:hover {
  background: rgba(1, 185, 183, 1);
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #ffd700;
  text-align: center;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px #2c2c2c, 0 0 10px #ffd700, 0 0 20px #ffd700;
  -webkit-text-stroke: 1px #333;
  //padding: 5px 15px;
}

.units-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.unit-item {
  background: rgba(14, 46, 44, 0.8);
  border: 1px solid #c2d4e7;
  border-radius: 8px;
  margin: 15px;
}

.unit-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.unit-logo {
  width: 130px;
  height: 80px;
  border-radius: 4px;
  margin-right: 15px;
  object-fit: cover;
}

.unit-info {
  flex: 1;
}

.unit-name {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 5px;
}

.unit-code {
  font-size: 12px;
  color: #aaa;
}

.unit-content {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #fff;
}
</style>
